module.exports = __webpack_public_path__ + "static/media/ESQUIZOFRENIA.ee73eb2f.png";